<template>
    <div class="text-center">
        <div class="loading-overlay"></div>
        <div class="spinner-border text-black custom-spinner" role="status"></div>
    </div>
</template>

<script>
    export default {
        name: 'Loading'
    }
</script>